import {AQL_CONSTANTS} from '../../../../../constants/aql.constants';
import {TOOLTIPS} from '../../../../../constants/tooltips.constants';
import ViewModes from '../../../../../core/enums/view-modes.types';
import BundleSpecModel from '../../../../../core/models/distribution/BundleSpecModel';
import QueryResultsPreviewModel from '../../../../../core/models/distribution/QueryResultsPreviewModel';
import ViewHelpers from '../../../../../core/utils/view.helpers';
import ValidationsService from '../../../../../services/validations.service';
import CreateBundleDAO from './DAO/CreateBundleDAO';

const FILTERED_REPOS = ['_intransit'];
const MAX_OPTIONS = 100;
const AQL_MODAL_CLASS = '.aql-query-create-edit-modal';

export default class AqlQueryCreateEditComponent {
	constructor() {
		this.template = require('./aql.query.create.edit.view.html');
		this.controller = AqlQueryCreateEditController;
		this.bindings = {
			aqlQueryModel: '=',
			onSubmit: '&',
			isValidQuery: '=',
			allQueriesList: '<',
			viewMode: '<',
			wizardApi: '=',
			showQueryForm: '<'
		};
	}
}

AqlQueryCreateEditComponent.META = {
	name: 'aqlQueryCreateEdit'
};

class AqlQueryCreateEditController {

	constructor($stateParams, $scope, $window, validationsService, JFrogTableViewOptions, createBundleDAO, JFrogEventBus, JFrogNotifications) {
		this.$stateParams = $stateParams;
		this.$scope = $scope;
        this.$window = $window;
        this.validationsService = validationsService;
		this.JFrogTableViewOptions = JFrogTableViewOptions;
		this.createBundleResource = createBundleDAO.Resource;
		this.previewData = new QueryResultsPreviewModel([]);
		this.JFrogEventBus = JFrogEventBus;
		this.JFrogNotifications = JFrogNotifications;

		this.logicalOperators = [
			{value: AQL_CONSTANTS.LOGICAL_OPERATORS.AND, text: 'And'},
			{value: AQL_CONSTANTS.LOGICAL_OPERATORS.OR, text: 'Or'}
		];
		this.$scope.$watchGroup([
			'$ctrl.aqlQueryModel.release_bundle_query_fields.included_logical_operator',
			'$ctrl.aqlQueryModel.release_bundle_query_fields.search_properties_logical_operator',
			'$ctrl.aqlQueryModel.release_bundle_query_fields.repositories'
		], () => {
			this.generateBeautifiedAql();
		});

		this.newPathMappingName = '';
		this.newPathMappingValue = '';

		this.repositoriesSelectionConfig = {
			plugins: {'remove_button':{}, 'infinite_scroll':{scrollRatio: 0.95, scrollStep: 1}},
			persist: true,
			maxOptions: MAX_OPTIONS,
			maxItems: null,
			//delimiter: '|',
			create: false,
			valueField: 'name',
			labelField: 'name',
			searchField: ['name','type'],
			loadingClass:'loading',
			render: {
				option: (item) => `<div><i class="icon icon-${item.type}"></i>&nbsp&nbsp ${item.name}</div>`,
				item: (item) => `<div><i class="icon icon-${item.type}"></i>&nbsp&nbsp ${item.name}</div>`,
			},
			load: (query, callback) => {
				if (!query.length) return callback();
                const res = this.allRepositories && this.allRepositories.filter(
                    ({name, type}) => (name && name.startsWith(query)) || (type && type.startsWith(query))
                );
                callback(res.slice(0, MAX_OPTIONS));
			}
		};

		this.allRepositories = [];
	}

	$onInit() {
        this.setMicroservices()
		this.prePopulateRepos();
		this.initWizard();
		this.setPreviewTable();
		this.initValidations();
		this.initTooltips();
	}

	toggleSpinner(isOn, className) {
        if (isOn) {
            window.store.dispatch('ENABLE_LOCAL_LOADER', className);
        } else {
            window.store.dispatch('DISABLE_LOCAL_LOADER', className);
        }
    }

    getMicroservices() {
        return this.$window.store.getters['common/context/GET_MICROSERVICES'];
    }

    getMicroservicesNames() {
        return this.$window.store.getters['common/context/GET_MICROSERVICES_CONSTANTS'];
    }

    setMicroservices() {
        this.microservices = this.getMicroservices();
        this.microservicesNames = this.getMicroservicesNames();
    }

	initWizard() {
		this.editable = this.viewMode === ViewModes.CREATE || this.viewMode === ViewModes.EDIT;
		this.showAQL = !this.showQueryForm;
		this.wizardApi.onStepChange = this.onStepChange.bind(this);
		this.originalQueryName = angular.copy(this.aqlQueryModel.query_name);

		this.QUERY_WIZARD_STEPS = [
			{name: 'Query Details', step: 0, active: true},
			{name: 'Additional Details', step: 1, active: true},
            {name: 'Preview Artifacts', step: 2, active: this.editable},
		];
	}

	initValidations() {
		this.additionalPropertyNameValidations = {
			customNameValidationCodes: 'additionalProperties',
			customNameValidationParams: {
				'strict.alpha.numeric.pattern': '!$value.length || $ctrl.validationsService.testCustomNamePattern($value,"^[a-zA-Z]+[a-zA-Z0-9_.]*$")',
				'name.min.length': '!$value.length || $ctrl.validationsService.testNameLength($value,0,120)'
			}
		};
		this.validationsService.defineCustomValidation('pathMappingTemplateSource', (templateSource) => {
			return !templateSource.length ||
				(AQL_CONSTANTS.PATH_MAPPING_TEMPLATES.ADD_FOLDER.source === templateSource) ||
				!_.find(AQL_CONSTANTS.PATH_MAPPING_TEMPLATES, (template) => template.source === templateSource);
		});

		this.validationsService.defineCustomValidation('pathMappingTemplateTarget', (templateTarget) => {
			return !templateTarget.length ||
				!_.find(AQL_CONSTANTS.PATH_MAPPING_TEMPLATES, (template) => template.target === templateTarget);
		});

		this.pathMappingValidations = {
			customNameValidationCodes: 'pathMapping',
			customNameValidationParams: {
				'replace.template.text' : `$ctrl.validationsService.testCustomValidation('pathMappingTemplateSource',$value)`
			},
			customValueValidationCodes: 'pathMapping',
			customValueValidationParams: {
				'replace.template.text' : `$ctrl.validationsService.testCustomValidation('pathMappingTemplateTarget',$value)`
			}
		};
	}

	initTooltips() {
		this.pathMappingsTooltip = TOOLTIPS.CREATE_BUNDLE.QUERY.PATH_MAPPINGS;
		this.additionalPropertiessTooltip = TOOLTIPS.CREATE_BUNDLE.QUERY.ADDITIONAL_PROPERTIES;
		this.searchPropertiesTooltip = TOOLTIPS.CREATE_BUNDLE.QUERY.SEARCH_PROPERTIES;
		this.includedPatternsTooltip = TOOLTIPS.CREATE_BUNDLE.QUERY.INCLUDED;
        this.includedPathTooltip = TOOLTIPS.CREATE_BUNDLE.QUERY.INCLUDED_PATH;
	}

	sourceArtifactoryHasRepos() {
		return this.allRepositories &&
			this.allRepositories.length &&
			this.allRepositories[0] &&
			(this.allRepositories[0].name ||
				(this.allRepositories[0][0] && this.allRepositories[0][0].name));
	}

	prePopulateRepos() {
		this.specialRepoTypes = {
			gitlfs: 'git-lfs',
			go: 'golang',
			yum: 'rpm',
			generic: 'generic'
		};

		this.createBundleResource.getReposInArtifactory().$promise.then((response)=>{
			this.allRepositories = response
                .filter(repo => FILTERED_REPOS.indexOf(repo.name) < 0)
                .map(repo => new Object({
                    name:repo.name,
                    type: this.specialRepoTypes[repo.type.toLowerCase()] || repo.type.toLowerCase()
                }));
		});
	}

	setPreviewTable() {
		this.tableViewOptions = new this.JFrogTableViewOptions(this.$scope)
			.setColumns(this.getPreviewTableColumns())
			.setRowsPerPage(5)
			.setEmptyTableText('No Artifacts')
			.setObjectName('Artifact');
		this.tableViewOptions.setData(this.previewData.files);
	}

	getPreviewTableColumns() {
		return [
			{
				field: 'artifact',
				header: 'Artifact',
				cellTemplate: `<div class="artifact">
									{{row.entity.artifact}}
								</div>`,
				width: '30%'
			},
			{
				field: 'path',
				header: 'Path',
				cellTemplate: `<div class="path">
									{{row.entity.path}}
								</div>`,
				width: '30%'
			},
            {
                field: 'targetPath',
                header: 'Target Path',
                cellTemplate: `<div class="path">
									{{row.entity.targetPath}}
								</div>`,
                width: '30%'
            },
			// {
			// 	field: 'xray_status',
			// 	header: 'Xray Status',
			// 	cellTemplate: `<div class="xray-status" disable-tooltip-on-overflow>
			// 						<div class="blocked" ng-if="row.entity.xray_status.blocked">
			// 							<i class="icon icon-info"
			// 								jf-tooltip="{{row.entity.xray_status.blocked_reason}}"></i>
			// 								Blocked
			// 						</div>
			// 					</div>`,
			// 	width: '15%',
            //     isVisible: () => this.hasXray()
			// },
			{
				field: 'size',
				header: 'Size',
				filterable: false, // cannot filter with filesize pipe
				cellTemplate: `<div class="size">
									{{ row.entity.size | filesize }}
								</div>`,
				width: '10%'
			}
		];
	}

	hasXray() {
        return this.microservices && this.microservices[this.microservicesNames.XRAY];
    }

	onPreview() {
		if(!this.aqlQueryModel.aql.length) {
			this.previewData = new QueryResultsPreviewModel([]);
			return this.tableViewOptions.setData(this.previewData.files);
		}
		this.toggleSpinner(true, AQL_MODAL_CLASS);
		this.createBundleResource.queryDryRun(
			new BundleSpecModel({
				queries: [this.aqlQueryModel]
			}).build()
		).$promise.then(response => {
            this.toggleSpinner(false, AQL_MODAL_CLASS);
            if(!response) {
				this.previewData = new QueryResultsPreviewModel([]);
				return this.tableViewOptions.setData(this.previewData.files);
			}
			this.previewData = new QueryResultsPreviewModel(response);
			this.tableViewOptions.setData(this.previewData.files);
		}, (error) => {
            this.toggleSpinner(false, AQL_MODAL_CLASS);
            this.JFrogNotifications.create({error: error.data.errors[0].defaultMessage});
			this.previewData = new QueryResultsPreviewModel([]);
			this.tableViewOptions.setData(this.previewData.files);
		});
	}

	onTabSwitch(wizardElement) {
		this.wizardApi.step = _.findIndex(this.QUERY_WIZARD_STEPS,(item => item.name === wizardElement));

        if(this.wizardApi.step > 0 && this.editable) {
			if(!this.showQueryForm) {
				this.generateBeautifiedAql();
			} else {
				this.buildAql();
			}
		}
		if(this.wizardApi.step === 2){
			this.onPreview();
		}
	}

	onStepChange(direction) {
		if(direction === 'up') {
			this.wizardApi.step = (_.find(this.QUERY_WIZARD_STEPS, item => (item.step > this.wizardApi.step) && item.active)).step;
		} else if(direction === 'down') {
			this.wizardApi.step = (_.find(this.QUERY_WIZARD_STEPS.reverse(), item => (item.step < this.wizardApi.step) && item.active)).step;
			this.QUERY_WIZARD_STEPS.reverse();
		}
		this.JFrogEventBus.dispatch(
			this.JFrogEventBus.getEventsDefinition().WIZARD_TAB_CHANGE,
			this.QUERY_WIZARD_STEPS[this.wizardApi.step].name
		);
	}

	set isValidQuery(value) {
		return value;
	}

	get isValidQuery() {
		return  this.aqlQueryModel &&
				this.aqlQueryModel.query_name && this.aqlQueryModel.query_name.length &&
				this.aqlQueryModel.aql && this.aqlQueryModel.aql.length &&
				this.aqlCreateEditForm.$valid &&
				// Validation is necessary since the 'save' button is on last wizard-tab and form fields that are on
				// the first tab are not rendered hence the form becomes 'valid'
				this.validationsService.testNamePattern(this.aqlQueryModel.query_name) &&
				this.validationsService.testNameLength(this.aqlQueryModel.query_name) &&
				this.validateNameDoesNotExists(this.aqlQueryModel.query_name);
	}

	validateNameDoesNotExists($value) {
		return (this.originalQueryName === $value) ||
			!this.validationsService.testNameExists($value, this.allQueriesList);
	}

	buildAql() {
		this.aqlQueryModel.aql = this.aqlQueryModel.build().aql;
	}

	beautifyAQL() {
		this.beautifiedAQL = ViewHelpers.beautifyAQL(this.aqlQueryModel.aql);
	}

	generateBeautifiedAql() {
		this.buildAql();
		this.beautifyAQL();

		if(!this.showQueryForm) {
			this.aqlQueryModel.aql = this.beautifiedAQL;
		}
	}

	initMappingTemplates(actionsController) {
		this.mappingTemplates = actionsController;
		if (!this.mappingTemplates) {
			return;
		}
		this.mappingTemplates.setActionsDictionary(this.getMappingTemplatesDictionary());
		this.mappingTemplates.setActions(this.getMappingTemplates());
	}

	getMappingTemplatesDictionary() {
		let dictionary = {};
		dictionary.moveRepo = {title: 'Change Repository'};
		dictionary.addFolder = {title: 'Change Folder'};
		dictionary.renameFolder = {title: 'Rename Folder'};
		return dictionary;
	}

	getMappingTemplates() {
		return [{
			name: 'moveRepo',
			action: () => {
				this.injectMappingTemplate(AQL_CONSTANTS.PATH_MAPPING_TEMPLATES.REPLACE_REPO);
			}
		}, {
			name: 'addFolder',
			action: () => {
				this.injectMappingTemplate(AQL_CONSTANTS.PATH_MAPPING_TEMPLATES.ADD_FOLDER);
			}
		}, {
			name: 'renameFolder',
			action: () => {
				this.injectMappingTemplate(AQL_CONSTANTS.PATH_MAPPING_TEMPLATES.REPLACE_FOLDER);
			}
		}];
	}

	injectMappingTemplate(snippet) {
		this.newPathMappingName = angular.copy(snippet.source);
		this.newPathMappingValue = angular.copy(snippet.target);
	}
}

AqlQueryCreateEditController.$inject = [
	'$stateParams',
	'$scope',
    '$window',
	ValidationsService.META.name,
	'JFrogTableViewOptions',
	CreateBundleDAO.META.name,
	'JFrogEventBus',
	'JFrogNotifications'
];




// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/components/bundle/create/aql.query.create.edit.component.js